/**
 * Cold-route import thunks — the single source of truth for what lazy-loads.
 * App.tsx wraps these in lazyWithRetry for rendering; useBackgroundStream drains the
 * same thunks during idle time so a visit after the stream completes never chunk-stalls.
 * Hot routes (Dashboard, Clients, ClientDetail, Reviews, ReviewDetail, Login) are
 * static imports in App.tsx and must NOT appear here.
 */
export const coldRouteLoaders = [
  { name: 'MeetingsPage', load: () => import('../pages/MeetingsPage') },
  { name: 'ActiveMeetingPage', load: () => import('../pages/ActiveMeetingPage') },
  { name: 'ActionItemsPage', load: () => import('../pages/ActionItemsPage') },
  { name: 'WorkloadPage', load: () => import('../pages/WorkloadPage') },
  { name: 'ProductivityPage', load: () => import('../pages/ProductivityPage') },
  { name: 'TaskLogPage', load: () => import('../pages/TaskLogPage') },
  { name: 'BookkeepingPage', load: () => import('../pages/BookkeepingPage') },
  { name: 'SettingsPage', load: () => import('../pages/SettingsPage') },
  { name: 'StaffSettingsPage', load: () => import('../pages/StaffSettingsPage') },
  { name: 'EmailTemplatesPage', load: () => import('../pages/EmailTemplatesPage') },
  { name: 'PatchNotesPage', load: () => import('../pages/PatchNotesPage') },
  { name: 'QuickStartPage', load: () => import('../pages/QuickStartPage') },
  { name: 'NotificationsPage', load: () => import('../pages/NotificationsPage') },
] as const;
